/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ExternalLinkIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="external-link"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M10.75 13.25L20.5 3.5M20.5 3.5L20.5 10.394M20.5 3.5L13.606 3.5" data-tinysvg-shape="arrow" data-tinysvg-arrow="10.75 13.25 20.5 3.5 50" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M18 13.5L18 18.5C18 19.605 17.105 20.5 16 20.5L5.5 20.5C4.395 20.5 3.5 19.605 3.5 18.5L3.5 8C3.5 6.895 4.395 6 5.5 6L10.5 6" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
